module.exports = __webpack_public_path__ + "img/淘宝.bd443270.png";